import { Component } from '@angular/core';

@Component({
  selector: 'citydeals-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
